import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { makeStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import Avatar from '@material-ui/core/Avatar';
import Typography from '@material-ui/core/Typography';
import CircularProgress from '@material-ui/core/CircularProgress';
import { useUrlSettings } from 'contexts/UrlSettingsContext';
import { request } from 'utilities/graph';
import { getClient } from './queries';
import { Storage } from 'aws-amplify';

const useStyles = makeStyles((theme) => ({
  button: {
    height: 60,
    borderRadius: 10,
    margin: 8,
  },
  biLogo: {
    border: '5px solid #034E8C',
    width: 150,
    height: 150,
    padding: 10,
    backgroundColor: '#fff',
  },
  logo: {
    border: '5px solid #00913A',
    width: 150,
    height: 150,
    padding: 20,
    backgroundColor: '#fff',
  },
  facilityAvatar: {
    border: '5px solid #00913A',
    width: 150,
    height: 150,
    padding: 20,
    backgroundColor: '#fff',
  },
  groupPurchaseRules: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    margin: '0 auto',
    padding: theme.spacing(2),
    color: '#00913A',
    backgroundColor: 'rgba(229, 248, 191, 0.56)',
    width: '100%',
  },
  rulesText: {
    whiteSpace: 'pre-wrap',
    lineHeight: 1.6,
  },
  imageContainer: {
    position: 'relative',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  loadingOverlay: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: 'rgba(255, 255, 255, 0.8)',
    zIndex: 1,
  },
  loadingContainer: {
    width: '100%',
    height: 600,
    backgroundColor: '#fff',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  avatarLoadingContainer: {
    width: 150,
    height: 150,
    backgroundColor: '#fff',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: '50%',
    border: '5px solid #00913A',
  },
}));

export default function CategorySelect({ onComplete }) {
  const { t } = useTranslation();
  const classes = useStyles();
  const { settings: urlSettings } = useUrlSettings();
  const [facilitySettings, setFacilitySettings] = useState(null);
  const [homeImage, setHomeImage] = useState(null);
  const [avatarImage, setAvatarImage] = useState(null);
  const [isHomeImageLoading, setIsHomeImageLoading] = useState(false);
  const [isAvatarImageLoading, setIsAvatarImageLoading] = useState(false);

  console.log('urlSettings', urlSettings);

  useEffect(() => {
    const fetchFacilitySettings = async () => {
      try {
        const facilityId = urlSettings?.clientId;
        if (facilityId) {
          const { data: { getClient: client } } = await request(getClient, { id: facilityId });
          setFacilitySettings(client?.facilitySettings);
        }
      } catch (error) {
        console.error('Error fetching facility settings:', error);
      }
    };

    fetchFacilitySettings();
  }, []);

  useEffect(() => {
    (async () => {
      if (facilitySettings?.groupPurchaseHomeImageS3Keys?.[0]) {
        setIsHomeImageLoading(true);
        try {
          const image = await Storage.get(facilitySettings.groupPurchaseHomeImageS3Keys[0]);
          setHomeImage(image);
        } catch (error) {
          console.error('Error loading home image:', error);
        } finally {
          setIsHomeImageLoading(false);
        }
      } else {
        setIsHomeImageLoading(false);
      }
    })();
  }, [facilitySettings?.groupPurchaseHomeImageS3Keys]);

  useEffect(() => {
    (async () => {
      if (facilitySettings?.facilityAvatarS3Keys?.[0]) {
        setIsAvatarImageLoading(true);
        try {
          const image = await Storage.get(facilitySettings.facilityAvatarS3Keys[0]);
          setAvatarImage(image);
        } catch (error) {
          console.error('Error loading avatar image:', error);
        } finally {
          setIsAvatarImageLoading(false);
        }
      } else {
        setIsAvatarImageLoading(false);
      }
    })();
  }, [facilitySettings?.facilityAvatarS3Keys]);

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        {isHomeImageLoading ? (
          <div className={classes.loadingContainer}>
            <CircularProgress />
          </div>
        ) : homeImage ? (
          <img src={homeImage} style={{ height: 'auto', width: '100%' }} alt="Homepage Banner" />
        ) : null}
      </Grid>

      {!isHomeImageLoading && !isAvatarImageLoading && (
        <>
          <Grid container item alignItems="center" justifyContent="center" style={{ marginTop: -100 }}>
            {avatarImage ? (
              <Avatar alt="Facility Logo" src={avatarImage} className={classes.facilityAvatar} />
            ) : null}
          </Grid>

          {(!urlSettings?.isOfficialVersion) &&
          <Grid container item xs={12} justifyContent="center" style={{ marginTop: 16 }}>
            請注意！此為測試環境，並不會真的送出訂單喔！
          </Grid>}

          {facilitySettings?.clientGroupPurchaseRule && (
            <Grid item xs={12}>
              <div className={classes.groupPurchaseRules}>
                <Typography variant="h6" gutterBottom style={{ borderBottom: '2px solid #00913A' }}>
                  團購注意事項
                </Typography>
                <Typography variant="body1" className={classes.rulesText}>
                  {facilitySettings.clientGroupPurchaseRule}
                </Typography>
              </div>
            </Grid>
          )}

          <Grid container item xs={12} justifyContent="center" style={{ marginTop: 16 }}>
            <Button
              variant="contained"
              color="primary"
              onClick={()=>{
                onComplete('meals');
              }}
              size="large"
              className={classes.button}
            >
              {t('立即訂餐')}
            </Button>
            {/* <Button
              disabled
              variant="contained"
              color="primary"
              onClick={()=>{
                onComplete('stuffs');
              }}
              size="large"
              className={classes.button}
            >
              安排宅配
            </Button> */}
          </Grid>
        </>
      )}
    </Grid>

  );
}

CategorySelect.propTypes = {
  onComplete: PropTypes.func,
};
